import { PrePanelInformationExamples } from "../mocks/data/productService/prepanel";
// import { PrePanelProductList } from "../mocks/data/productService/prePanelProductList";
import api from "./api";

const { productServiceAPI, aggregatedServiceAPI} = api;

const PREPANEL_ONLOAD = "/prePanel/Onload"
const PREPANEL_LIST = "/productInfo/prePanelList"
const PREPANEL_INFO = "/productInfo/prepanel"
const PREPANEL_INFO_SAVE = "/ProductVendorAggregator/updateIdeaForPrePanel"
const CP_FETCH_PRE_PANEL_LIST_PATH = "/productInfo/prePanelList"
const CP_FETCH_BUSINESS_REVIEW_PANEL_LIST_PATH = "/productInfo/businessReviewPanelList"
const CP_FETCH_TASTING_PANEL_LIST_PATH = "/productInfo/tastingPanelList"

const PrepanelService = {
    getPrepanel: async (vendorId: string): Promise<any> =>{
        const resp = PrePanelInformationExamples[vendorId];
        return resp ? resp : null;
    },
    
    createOrUpdatePrepanel: async (data: any): Promise<any> => {
        try {
            // localStorage.setItem('prepanelData', JSON.stringify(data));
            const response = {
                ok: true,
                statusText: "OK",
                json: async () => {
                    return {
                        message: "Prepanel created successfully",
                        data: data
                };
            }
        }
            if (!response.ok) {
                throw new Error(`Error creating prepanel: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error(error);
            throw error;
        }
    },
    getProducts: async (): Promise<any> => {
        try {
            const resp = await productServiceAPI.get(PREPANEL_LIST); 
            return resp.data; 
        } catch (error) {
            throw error; 
        }
    },
    getPrePanelOnLoadData: async () => {
        try {
            const resp = await productServiceAPI.get( PREPANEL_ONLOAD ); 
            return resp.data; 
        } catch (error) {
            throw error; 
        }
    },
    getPrePanelInformation: async (ideaId: string , assessmentId: string, ingredientId: string) => {
        try {
            const resp = await productServiceAPI.get( `${PREPANEL_INFO}/${ideaId}?assessmentId=${assessmentId}&ingredientId=${ingredientId}`); 
            return resp.data; 
        } catch (error) {
            throw error; 
        }
    },
    savePrePanelInformation: async (data: any) => {
        try {
            const resp = await aggregatedServiceAPI.post(PREPANEL_INFO_SAVE, data); 
            console.log("Response from savePrePanelInformation:", resp);
            return resp; 
        } catch (error) {
            throw error; 
        }
    },
    fetchPrePanelList: async () => {
        try {
          const resp = await productServiceAPI.get(CP_FETCH_PRE_PANEL_LIST_PATH);
          return resp.data;
        } catch (error) {
          throw error;
        }
      },
      fetchBusinessReviewPanel: async () => {
        try {
          const resp = await productServiceAPI.get(CP_FETCH_BUSINESS_REVIEW_PANEL_LIST_PATH);
          return resp.data;
        } catch (error) {
          throw error;
        }
      },
      fetchTastingPanel: async () => {
        try {
        const resp = await productServiceAPI.get(CP_FETCH_TASTING_PANEL_LIST_PATH);
        return resp.data;
        } catch (error) {
        throw error;
        }
      }
};

export default PrepanelService;